import * as React from 'react';

const PencilChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="pencil-chunky_svg__eds-icon--pencil-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="pencil-chunky_svg__eds-icon--pencil-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 17l8-8 1 1-8 8-1-1zm-2-.3V20h3.3l9.8-9.8-3.3-3.3L4 16.7z"
        />
        <path
            id="pencil-chunky_svg__eds-icon--pencil-chunky_eraser"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.7 7.6c.3-.3.3-.9 0-1.3l-2.1-2.1c-.3-.3-.9-.3-1.3 0l-1.6 1.6L18 9.1l1.7-1.5z"
        />
    </svg>
);

PencilChunkySvg.displayName = 'PencilChunkySvg';
export default PencilChunkySvg;
